module.exports = __webpack_public_path__ + "img/71.c92c250.png";